// extracted by mini-css-extract-plugin
export default {"show-more-button":"xacJ_","showMoreButton":"xacJ_"};